export enum Frequency {
  OnceOff = 'OnceOff',
  Monthly = 'Monthly',
}
export interface IFrequency {
  id: number;
  name: string;
  code: string;
}
